export default __webpack_public_path__ + "locales/es/Errors.json?hash=4386c86f8b968af29ec367ba66b45edf";